var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageInfo16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconInfo16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-Icons/pictograms/picto-ui-info-32",
    fill: "#0063FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C15.9949616,12.4161893 12.4161893,15.9949616 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1.14285714 C4.21290457,1.14285714 1.14285714,4.21290457 1.14285714,8 C1.14285714,11.7870954 4.21290457,14.8571429 8,14.8571429 C11.7870954,14.8571429 14.8571429,11.7870954 14.8571429,8 C14.8530487,4.21460174 11.7853983,1.14695134 8,1.14285714 Z M8.01371429,5.888 C8.54857143,5.888 8.98742857,6.32685714 8.98742857,6.83428571 L8.98742857,6.83428571 L8.98742857,12.2651429 C8.98742857,12.7862857 8.54857143,13.2114286 8.01371429,13.2114286 C7.46514286,13.2114286 7.04,12.7862857 7.04,12.2651429 L7.04,12.2651429 L7.04,6.83428571 C7.04,6.32685714 7.46514286,5.888 8.01371429,5.888 Z M8.01371429,3.04914286 C8.65828571,3.04914286 9.16571429,3.54285714 9.16571429,4.17371429 C9.16571429,4.80457143 8.65828571,5.32571429 8.01371429,5.32571429 C7.35542857,5.32571429 6.83428571,4.80457143 6.83428571,4.17371429 C6.83428571,3.54285714 7.35542857,3.04914286 8.01371429,3.04914286 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageInfo16);
export default __webpack_public_path__ + "static/media/messageInfo16.c2fcd5dbd0a3cfe9558646477ac81812.svg";
export { ForwardRef as ReactComponent };